export const SHOW_MENU = 'SHOW_MENU'
export const HIDE_MENU = 'HIDE_MENU'
export const SHOW_LOADING_BAR = 'SHOW_LOADING_BAR'
export const HIDE_LOADING_BAR = 'HIDE_LOADING_BAR'
export const SET_TOKEN = 'SET_TOKEN'
export const SET_USER = 'SET_USER'
export const SHOW_ERROR = 'SHOW_ERROR'
export const HIDE_ERROR = 'HIDE_ERROR'
export const SET_PAGE_TITLE = 'SET_PAGE_TITLE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js